import "./SubordinatesOverview.css";

import { Check, X, Bell, ChevronRight, LoaderCircle } from "lucide-react";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { SendReminderToManagerAsync } from "../../services/SupervisorService";
import { SubordinateSummary } from "../../types/SubordinateSummary";
import { useTimePeriodContext } from "../../contexts/TimePeriodContext";

interface Props {
  selectedSubordinateId: number;
  setSelectedSubordinateId: Dispatch<SetStateAction<number>>;
  subordinateStatuses: SubordinateSummary[];
}

function SubordinatesOverview({
  selectedSubordinateId,
  setSelectedSubordinateId,
  subordinateStatuses,
}: Props) {
  const [reminderSent, setReminderSent] = useState(false);
  const { selectedPeriod } = useTimePeriodContext();

  useEffect(() => {
    if (!reminderSent) return;

    const timer = setTimeout(() => setReminderSent(false), 3000);
    return () => clearTimeout(timer);
  }, [reminderSent]);

  async function sendReminder(managerMail: string) {
    setReminderSent(true);
    await SendReminderToManagerAsync(managerMail, selectedPeriod.Month, selectedPeriod.Year);
  }

  return (
    <>
      <div className="subordinates-table">
        <div className="table-header">
          <span>
            <span className="full-text">Mitarbeiter</span>
            <span className="short-text">MA</span>
          </span>

          <span className="header-text">
            <span className="full-text">Projektleiter?</span>
            <span className="short-text">PL?</span>
          </span>

          <span className="header-text">
            <span className="full-text">Vorgesetzter?</span>
            <span className="short-text">VG?</span>
          </span>

          <span className="header-text">
            <span className="full-text">Erinnern</span>
            <span className="short-text">Er.</span>
          </span>
        </div>

        <div className="table-content">
          {subordinateStatuses.map((s) => (
            <div
              key={s.id}
              className={`table-row ${selectedSubordinateId === s.id ? "selected" : ""}`}
              onClick={() => {
                setSelectedSubordinateId(s.id);
              }}
            >
              <span className="subordinate-name">{s.displayName}</span>

              <span>{s.hasCompletedCheck ? <Check color="green" /> : <X color="red" />}</span>

              <span>
                {s.checkedBySupervisor ? (
                  <Check color="green" />
                ) : (
                  <ChevronRight className="redirect-to-check" />
                )}
              </span>

              <span>
                {reminderSent ? (
                  <LoaderCircle className="loader-spin" />
                ) : s.checkedBySupervisor && s.hasCompletedCheck ? (
                  <Bell className="send-reminder disabled" />
                ) : (
                  <Bell className="send-reminder" onClick={() => sendReminder(s.managerEmail)} />
                )}
              </span>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default SubordinatesOverview;
